
const convertToNearestDay = (time, timezone) => {
    timezone = timezone * 3600;
    return (time - time % 3600 - ((time - time % 3600) + timezone) % 86400);
}

export default convertToNearestDay;